import { LibraryExemplarStatusValues } from "global/constants"

export function DisponibleExemplarsAmount(exemplars) {
    return exemplars.filter(exemplar => exemplar.status === LibraryExemplarStatusValues.DISPONIBLE).length;
}